(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cerlume-detail-300"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-cer300-view]');
    if (thumb) {
      const root = thumb.closest('.cer300');
      const main = root.querySelector('.cer300-main');
      main.removeAttribute('srcset');
      main.src = thumb.dataset.cer300View;
      main.alt = thumb.dataset.cer300Alt;
      root.querySelectorAll('[data-cer300-view]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const catalogue = event.target.closest('[data-cer300-catalogue]');
    if (catalogue) catalogue.closest('.cer300').querySelector('[data-cer300-catalogue-input]').checked = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerlume-detail-400"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-cer400-view]');
    if (thumb) {
      const root = thumb.closest('.cer400');
      const main = root.querySelector('.cer400-main');
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-cer400-view');
      main.alt = thumb.getAttribute('data-cer400-alt');
      root.querySelectorAll('[data-cer400-view]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const catalogue = event.target.closest('[data-cer400-catalogue]');
    if (catalogue) catalogue.closest('.cer400').querySelector('[data-cer400-catalogue-input]').checked = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerlume-detail-electrical"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-cer-elec-view]');
    if (thumb) {
      const root = thumb.closest('.cer-elec');
      const main = root.querySelector('.cer-elec-main');
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-cer-elec-view');
      main.alt = thumb.getAttribute('data-cer-elec-alt');
      main.closest('.cer-electric-media').style.cssText = thumb.querySelector('.cer-electric-media').style.cssText;
      root.querySelectorAll('[data-cer-elec-view]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const catalogue = event.target.closest('[data-cer-elec-catalogue]');
    if (catalogue) catalogue.closest('.cer-elec').querySelector('[data-cer-elec-catalogue-input]').checked = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerlume-detail-h22"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-cerh22-view]');
    if (thumb) {
      const root = thumb.closest('.cerh22');
      const main = root.querySelector('.cerh22-main');
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-cerh22-view');
      main.alt = thumb.getAttribute('data-cerh22-alt');
      root.querySelectorAll('[data-cerh22-view]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const catalogue = event.target.closest('[data-cerh22-catalogue]');
    if (catalogue) catalogue.closest('.cerh22').querySelector('[data-cerh22-catalogue-input]').checked = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerlume-detail-range"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-cer-range-view]');
    if (thumb) {
      const root = thumb.closest('.cer-range');
      const main = root.querySelector('.cer-range-main');
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-cer-range-view');
      main.alt = thumb.getAttribute('data-cer-range-alt');
      root.querySelectorAll('[data-cer-range-view]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const catalogue = event.target.closest('[data-cer-range-catalogue]');
    if (catalogue) catalogue.closest('.cer-range').querySelector('[data-cer-range-catalogue-input]').checked = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerlume-electrical-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('button[aria-controls]');
    const source = button?.querySelector('.cer-electric-media');
    if (!source) return;
    const main = document.getElementById(button.getAttribute('aria-controls'));
    const frame = main?.closest('.cer-electric-media');
    if (!frame) return;
    for (const key of ['--media-w', '--media-h', '--media-x', '--media-y']) {
      frame.style.setProperty(key, source.style.getPropertyValue(key));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerlume-lazy-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cerlume-lazy-video')) {
    customElements.define('cerlume-lazy-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.manualPause = false;
        this.onVisibility = () => this.syncPlayback();
        this.onMediaChange = () => {
          if (this.loaded) this.loadSource();
          this.syncPlayback();
        };
        this.onPause = () => {
          if (this.inView && !document.hidden && !this.changingSource) this.manualPause = true;
        };
        this.onPlay = () => { this.manualPause = false; };
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.mobile.addEventListener('change', this.onMediaChange);
        this.reducedMotion.addEventListener('change', this.onVisibility);
        if ('IntersectionObserver' in window) {
          this.loader = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.loadSource();
              this.loader.disconnect();
            }
          }, { rootMargin: '1200px 0px' });
          this.player = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.15);
            this.syncPlayback();
          }, { threshold: [0, 0.15] });
          this.loader.observe(this.video);
          this.player.observe(this.video);
        } else {
          this.loadSource();
        }
      }
      loadSource() {
        const source = this.mobile.matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
        if (!source || this.video.getAttribute('src') === source) return;
        this.changingSource = true;
        this.video.src = source;
        this.video.preload = 'auto';
        this.video.load();
        this.loaded = true;
        this.video.addEventListener('loadeddata', () => {
          this.changingSource = false;
          this.syncPlayback();
        }, { once: true });
      }
      syncPlayback() {
        if (document.hidden || !this.inView || this.reducedMotion.matches) {
          this.video.pause();
        } else if (this.loaded && !this.manualPause) {
          this.video.play().catch(() => {});
        }
      }
      disconnectedCallback() {
        this.loader?.disconnect();
        this.player?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.mobile?.removeEventListener('change', this.onMediaChange);
        this.reducedMotion?.removeEventListener('change', this.onVisibility);
        this.video?.removeEventListener('pause', this.onPause);
        this.video?.removeEventListener('play', this.onPlay);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
